import React, {useEffect} from 'react';
import { useSelector, useDispatch } from "react-redux";

const CatalogNumberGenerator = (props) => {
    // TODO move into store does not need to be a component
    const dispatch = useDispatch();
    const attributeSelections = useSelector(state => state.productDataReducer.attribute_selections)
    const product = useSelector(state => state.product)
    useEffect(() => {
        updateCatalogNumber();
    });

    const updateCatalogNumber = () => {
        const values = [];

        if (product.family) {
            values.push(product.family);
        }

        if (attributeSelections) {
            attributeSelections.forEach((sel) => values.push(sel.selection))
        }

        const catalogNumber = values.join(''); // + optionValues.sort().join('');
        const attributeCatalog = values.join('');
        dispatch({type: 'SET_CATALOG_NUMBER', value: catalogNumber});
        // this is strictly for monitor attribute changes manually
        dispatch({type: 'SET_ATTRIBUTE_CATALOG_NUMBER', value: attributeCatalog});
    }
    
    return (
        <div />
    )
}

export default CatalogNumberGenerator;